import React from 'react';
import { useEffect, useState } from 'react';
import './UploadHeader.css';
import { EXTENDED_HEADER_HEIGHT, MOBILE_EXTENDED_HEADER_HEIGHT } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { SearchBar } from '../../components/SearchBar/SearchBar';
import { CategoryFilter } from '../../components/CategoryFilter/CategoryFilter';
import { usePostHog } from 'posthog-js/react';

export function UploadHeader() {
    const posthog = usePostHog();
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleGoToFeed = () => {
        posthog.capture('clicked_go_to_feed_button');
        navigate('/feed');
    }

    const goToCustomContent = () => {
        posthog.capture('clicked_upload_custom_content_button');
        navigate('/upload');
    }
    const handleLinkClick = (sort) => {
        navigate(`/feed?sortBy=${sort}`);
    }

    return (
        <>
            {windowWidth > 768 ? (
                <div className="header" style={{ height: `${EXTENDED_HEADER_HEIGHT}px` }}>
                    <div className="feedHeaderContents">
                        <div className="feedHeaderTitleAndSearch">
                            <h1 className="feedTitle" onClick={handleGoToFeed}>Lava
                                <img className="feedTitleLogo" src={require('../../assets/images/logo-white.png')} />
                                amp
                            </h1>
                        </div>
                        <div>
                            <button className={`sortButton`} onClick={() => handleLinkClick('hot')}>Top Picks</button>
                            <button className={`sortButton`} onClick={() => handleLinkClick('top')}>Top Listens</button>
                            <button className={`sortButton`} onClick={() => handleLinkClick('latest')}>Most Recent</button>
                            <button className={`sortButton selected`} onClick={() => goToCustomContent()}>Upload your own!</button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="header" style={{ height: `${MOBILE_EXTENDED_HEADER_HEIGHT}px` }}>
                    <div className="feedHeaderContents">
                        <div className="feedHeaderTitleAndSearch">
                            <h1 className="feedTitle" style={{ fontSize: '32px', marginBottom: '5px', width: '100%', textAlign: 'center' }} onClick={handleGoToFeed}>
                                Lava
                                <img className="feedTitleLogo" src={require('../../assets/images/logo-white.png')} />
                                amp
                            </h1>
                            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '5px', width: '100%', justifyContent: 'center', gap: '15px' }}>
                                <button className={`sortButton selected`} onClick={() => goToCustomContent()}>Upload your own</button>
                                <button className={`sortButton`} onClick={() => handleLinkClick('hot')}>Top Picks</button>
                                <button className={`sortButton`} onClick={() => handleLinkClick('top')}>Top Listens</button>
                                <button className={`sortButton`} onClick={() => handleLinkClick('latest')}>Most Recent</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}